import { defineComponent as o, openBlock as r, createBlock as a, normalizeProps as n, guardReactiveProps as p, withCtx as l, renderSlot as c, createElementVNode as s } from "vue";
import i from "../CdrIcon.vue.mjs";
const d = /* @__PURE__ */ s("path", {
  role: "presentation",
  d: "M12.702 20.712a.997.997 0 01-1.43-.026c-5.05-4.985-7.763-7.71-8.137-8.173C2.575 11.818 2 10.312 2 9a6 6 0 0110-4.472 6 6 0 018.701 8.2c-.542.683-3.208 3.344-8 7.984z"
}, null, -1), _ = /* @__PURE__ */ o({
  name: "HeartFill",
  __name: "heart-fill",
  props: {
    props: {
      type: Object
    }
  },
  setup(e) {
    return (t, m) => (r(), a(i, n(p(e.props)), {
      default: l(() => [c(t.$slots, "default"), d]),
      _: 3
    }, 16));
  }
});
export {
  _ as default
};
